import React from 'react';
const items = [{
  emoji: '🚀',
  text: 'SISTEMA DE VENTA AUTOMÁTICA'
}, {
  emoji: '💎',
  text: 'ACCESO DE POR VIDA'
}, {
  emoji: '⚡',
  text: 'IMPLEMENTACIÓN PASO A PASO'
}, {
  emoji: '📈',
  text: 'PENSADO PARA PRINCIPIANTES'
}, {
  emoji: '📗',
  text: 'GUÍA COMPLETA SHOPIFY',
  badge: 'PRO'
}, {
  emoji: '🚀',
  text: 'SISTEMA DE VENTA AUTOMÁTICA'
}, {
  emoji: '💎',
  text: 'ACCESO DE POR VIDA'
}, {
  emoji: '⚡',
  text: 'IMPLEMENTACIÓN PASO A PASO'
}, {
  emoji: '📈',
  text: 'PENSADO PARA PRINCIPIANTES'
}, {
  emoji: '📗',
  text: 'GUÍA COMPLETA SHOPIFY',
  badge: 'PRO'
}];
export function MarqueeBanner() {
  return <div className="w-full bg-[#3a5249] relative overflow-hidden py-4 md:py-5" data-id="element-350">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-[#2d6b4f] to-transparent z-10 pointer-events-none" data-id="element-351" />
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-[#2d6b4f] to-transparent z-10 pointer-events-none" data-id="element-352" />
      <div className="flex animate-marquee whitespace-nowrap" data-id="element-353">
        {[...items, ...items].map((item, i) => <div key={i} className="inline-flex items-center gap-3 mx-4 md:mx-6 px-8 md:px-10 py-4 md:py-5 rounded-full border border-[#4a8a6e]/40 bg-[#3a7a5e]/30 flex-shrink-0" data-id="element-354">
            <span className="text-xl md:text-2xl" data-id="element-355">{item.emoji}</span>
            <span className="text-white font-bold text-base md:text-lg tracking-wide" data-id="element-356">
              {item.text}
            </span>
            {item.badge && <span className="ml-1 px-2.5 py-1 bg-[#4a8a6e]/40 text-white/80 text-xs md:text-sm font-bold rounded-md" data-id="element-357">
                {item.badge}
              </span>}
          </div>)}
      </div>
    </div>;
}